import { render, staticRenderFns } from "./IconCaretRight.vue?vue&type=template&id=09ef5e64&"
import script from "./IconCaretRight.vue?vue&type=script&lang=js&"
export * from "./IconCaretRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports